export const checkUploadFilesValid = (files, mimeTypes) => {
    const disallowedFileNames = []; // Initialize an empty array to store names of disallowed files
  
    // Iterate over the files array
    for (let i = 0; i < files?.length; i++) {
      const file = files[i];
      const { name, type, size } = file;
      // Check if the file's MIME type is not in the list of allowed MIME types
      if (!mimeTypes.includes(file.type)) {
        disallowedFileNames.push({
          name,
          type,
          size,
          reason: "File type not allowed for upload",
        }); // Add file name to disallowedFileNames array
      }
      //Check file size is more than 4Mb or not
      if (size > 4000000) {
        disallowedFileNames.push({
          name,
          type,
          size,
          reason: "File size more than 4mb is not allowed for upload",
        }); // Add file name to disallowedFileNames array
      }
    }
    return disallowedFileNames;
  };